import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectMapData, selectSelectedLabelId, setSelectedLabelId } from '@repo/store/maps/slices/mapData';
import { useLabelOperations } from '../../game-map/hooks/useLabelOperations';
export const LabelTools = () => {
  const $ = _c(19);
  const dispatch = useAppDispatch();
  const mapData = useAppSelector(selectMapData);
  const selectedLabelIdFromRedux = useAppSelector(selectSelectedLabelId);
  const {
    isAddingLabel,
    startAddingLabel,
    cancelAddingLabel,
    isCreating
  } = useLabelOperations();
  let t0;
  if ($[0] !== mapData?.labels?.features) {
    t0 = mapData?.labels?.features || [];
    $[0] = mapData?.labels?.features;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const labels = t0;
  let t1;
  if ($[2] !== startAddingLabel) {
    t1 = () => {
      startAddingLabel({
        title: "New Label",
        color: "#ffffff",
        fontSize: 18,
        minZoom: 1,
        maxZoom: 20
      });
    };
    $[2] = startAddingLabel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleStartAddingLabel = t1;
  let t2;
  if ($[4] !== dispatch) {
    t2 = labelId => {
      dispatch(setSelectedLabelId(labelId));
    };
    $[4] = dispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleLabelSelect = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>Add New Label</div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cancelAddingLabel || $[8] !== handleStartAddingLabel || $[9] !== isAddingLabel || $[10] !== isCreating) {
    t4 = <FlexColumn gap="8">{t3}<FlexRow gap="8">{!isAddingLabel ? <Button onClick={handleStartAddingLabel} variant="filled" color="brand" size="sm" disabled={isCreating}>Add Label</Button> : <Button onClick={cancelAddingLabel} variant="filled" color="error" size="sm">Cancel</Button>}</FlexRow></FlexColumn>;
    $[7] = cancelAddingLabel;
    $[8] = handleStartAddingLabel;
    $[9] = isAddingLabel;
    $[10] = isCreating;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleLabelSelect || $[13] !== labels || $[14] !== selectedLabelIdFromRedux) {
    t5 = labels.length > 0 && <FlexColumn gap="8"><div>Edit Existing Label</div><Select value={selectedLabelIdFromRedux ?? undefined} onValueChange={handleLabelSelect} placeholder="Select a label" size="sm" fullWidth={true} trigger={<Button color="primary" size="sm">{selectedLabelIdFromRedux ? labels.find(l => l.properties.externalId === selectedLabelIdFromRedux)?.properties.title || "Unnamed Label" : "Select a label"}</Button>}>{labels.map(_temp)}</Select></FlexColumn>;
    $[12] = handleLabelSelect;
    $[13] = labels;
    $[14] = selectedLabelIdFromRedux;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <FlexColumn gap="12">{t4}{t5}</FlexColumn>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
function _temp(label) {
  return <SelectItem key={label.properties.externalId} item={{
    label: label.properties.title || "Unnamed Label",
    value: label.properties.externalId
  }}>{label.properties.title || "Unnamed Label"}</SelectItem>;
}